import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom'; // Import Link
import { CartContext } from '../cart/ContextProvider';
import '../css/App.css'
import './CustomNav.css'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { logout } from '../Authentication/firebase';
import { useNavigate } from 'react-router-dom';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import CustomLoader from 'react-spinners/PuffLoader';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SearchComponent from './SearchBar';
import AccountCircleIcon from '@mui/icons-material/Person';




const CustomNav = () => {

    const { updateCatOnly, updateCategory, user, counter, wishlist, initialLoading } = useContext(CartContext);
    const [showDropdown, setShowDropdown] = useState(false);
    const [showSearchBar, setShowSearchBar] = useState(false);
    const [isFocused, setIsFocused] = useState(false)
    const navigate = useNavigate();

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    function handleClick(category) {
        updateCategory(category)
        updateCatOnly(category);
    }

    function handleLogout() {
        logout()
        navigate('/login');
    }




    return (

        <div>
            <div className='nav-bar'>
                {/* Brand */}
                <Link className="brand-link" to="/">Jackpot</Link>
                {/* category */}
                <ul className='ul-category'>
                    <li className='category-list'>
                        <Link className=" nav_link " aria-current="page" onClick={() => handleClick("casuals/all")} to="/casuals/all">Casuals <ArrowDropDownIcon /></Link>
                        <div className='dropdown_menu'>
                            <ul>
                                <li>
                                    <Link className="" aria-current="page" onClick={() => handleClick('casuals/all')} to="/casuals/all">All</Link>
                                </li>
                                <li>
                                    <Link className="" aria-current="page" onClick={() => handleClick('casuals/shirts')} to="/casuals/shirts">Shirts</Link>
                                </li>
                                <li>
                                    <Link className="" aria-current="page" onClick={() => handleClick('casuals/tshirts')} to="/casuals/tshirts">T-Shirts</Link>
                                </li>
                                <li>
                                    <Link className="" aria-current="page" onClick={() => handleClick('casuals/pants')} to="/casuals/pants">Pants</Link>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li className='category-list'><Link className=" nav_link" aria-current="page" onClick={() => handleClick("formals/all")} to="/formals/all">Formals <ArrowDropDownIcon /></Link>
                        <div className='dropdown_menu'>
                            <ul>
                                <li>
                                    <Link className="" aria-current="page" onClick={() => handleClick('formals/all')} to="/formals/all">All</Link>
                                </li>
                                <li>
                                    <Link className="" aria-current="page" onClick={() => handleClick('formals/shirts')} to="/formals/shirts">Shirts</Link>
                                </li>
                                <li>
                                    <Link className="" aria-current="page" onClick={() => handleClick('formals/pants')} to="/formals/pants">Pants</Link>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
                {/* Email */}
                <SearchComponent></SearchComponent>

                {/* Wishlist  */}
                <Link className="link-right" to="/wishlist">
                    <FavoriteBorderIcon />
                    {wishlist.length > 0 && (
                        <span className="position-absolute top-90 start-98 translate-middle badge rounded-circle">
                            {wishlist.length}
                        </span>
                    )}
                </Link>

                {/* Cart */}
                <Link className="link-right" to="/cart">
                    <ShoppingCartOutlinedIcon />
                    {counter === 0 ? null : <span className="position-absolute top-90 start-98 translate-middle badge rounded-circle ">{counter}</span>}
                </Link>


                <div className='userId'>
                    {initialLoading ? (
                        <div className='loader'>
                            <CustomLoader color="#000" size={25} speedMultiplier={2} />
                        </div>
                    ) : user ? (
                        <div className="dropdownContainer"
                         onMouseEnter={() => setShowDropdown(true)} onMouseLeave={() => setShowDropdown(false)}
                         >
                            <Link className='accountIcon' to='/profile' ><AccountCircleIcon  /></Link>
                            
                            {showDropdown && (
                                <div className="dropdownMenu">
                                    <ul>
                                        <li>
                                            <Link to="/profile">My Orders</Link>
                                        </li>
                                        <li>
                                            <Link to='/login' onClick={handleLogout}>Logout</Link>
                                        </li>
                                    </ul>
                                </div>
                             )}
                        </div>
                    ) : (
                        <div className='loginRegister'>
                            <Link className="nav-link" to='/login'>Login</Link>
                            <Link className="nav-link" to='/register'>Register</Link>
                        </div>
                    )}
                </div>
            </div>





            {/* Mobile view */}


            <nav class="navbar navbar-expand-lg navbar-light  bootnav">
                <Link class=" brand-link" to='/'>Jackpot</Link>

                <div className='bootnav-right'>
                    <Link to='/wishlist' className='link-right'>
                        <FavoriteBorderIcon className='fav-bootnav' />
                        {wishlist.length > 0 && (
                            <span className="position-absolute top-90 start-98 translate-middle badge rounded-circle">
                                {wishlist.length}
                            </span>
                        )}
                    </Link>

                    <Link className="link-right" to="/cart">
                        <ShoppingCartOutlinedIcon />
                        {counter === 0 ? null : <span className="position-absolute top-90 start-98 translate-middle badge rounded-circle ">{counter}</span>}
                    </Link>

                    <button class="navbar-toggler hamburger" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                </div>



                <div class="collapse navbar-collapse bootnav-items" id="navbarSupportedContent">
                    <ul class="navbar-nav mr-auto">

                        <li class="nav-item dropdown">

                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Casuals
                            </a>
                            <div class="dropdown-menu" aria-labelledby="navbarDropdown">

                                <Link className="dropdown-item" aria-current="page" onClick={() => handleClick('casuals/all')} to="/casuals/all">- All</Link>
                                <Link className="dropdown-item" aria-current="page" onClick={() => handleClick('casuals/shirts')} to="/casuals/shirts">- Shirts</Link>
                                <Link className="dropdown-item" aria-current="page" onClick={() => handleClick('casuals/tshirts')} to="/casuals/tshirts">- T-Shirts</Link>
                                <Link className="dropdown-item" aria-current="page" onClick={() => handleClick('casuals/pants')} to="/casuals/pants">- Pants</Link>

                            </div>
                        </li>

                        <li class="nav-item dropdown">

                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Formals
                            </a>
                            <div class="dropdown-menu" aria-labelledby="navbarDropdown">

                                <Link className="dropdown-item" aria-current="page" onClick={() => handleClick('formals/all')} to="/formals/all">- All</Link>
                                <Link className="dropdown-item" aria-current="page" onClick={() => handleClick('formals/shirts')} to="/formals/shirts">- Shirts</Link>
                                <Link className="dropdown-item" aria-current="page" onClick={() => handleClick('formals/pants')} to="/formals/pants">- Pants</Link>

                            </div>
                        </li>

                        <li className='nav-item'>
                            <div className='userId profileMob'>
                                {initialLoading ? (
                                    <div className='loader'>
                                        { }
                                        <CustomLoader color="#000" size={25} speedMultiplier={2} />
                                    </div>
                                ) :
                                    user ? (
                                        <div className="dropdown ">
                                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Profile
                                            </a>
                                            <div class="dropdown-menu" aria-labelledby="navbarDropdown">

                                                <Link className="dropdown-item" aria-current="page" to="/profile">- My Orders</Link>
                                                <Link className="dropdown-item" aria-current="page" to="/login" onClick={handleLogout}>- Logout</Link>


                                            </div>
                                        </div>
                                    ) :
                                        (<div className='logReg'>
                                            <div>
                                                <Link className="nav-link" to='/login'>Login</Link>
                                            </div>

                                            <div className='rdiv-logReg'>
                                                <Link className="nav-link reg" to='/register'>Register</Link>
                                            </div>
                                        </div>
                                        )}
                            </div>
                        </li>


                    </ul>

                </div>
            </nav>


        </div>
    );
};

export default CustomNav;